import { memo, useMemo } from "react";

import { BreadcrumbsView } from "./Breadcrumbs.view";

interface Props {
  items: { title: string; url: string }[];
}

const BreadcrumbsBase = ({ items }: Props) => {
  const updatedItems = useMemo(
    () => [{ title: "Home", url: "/" }, ...items],
    [items]
  );

  return <BreadcrumbsView items={updatedItems} />;
};

export const Breadcrumbs = memo(BreadcrumbsBase);
